import Vue from "vue";
import VueToast from "vue-toast-notification";

Vue.use(VueToast, {
  position: "bottom",
});
